import * as Tdlr_en from './tdlr.en.js';
import * as Tdlr_es from './tdlr.es.js';

const TdlrTuple = [
  { type: 'Tdlr', language: 'en', object: Tdlr_en.default },
  { type: 'Tdlr', language: 'es', object: Tdlr_es.default },
];

export default TdlrTuple;
